!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("@material-ui/core"), require("@material-ui/core/styles"), require("@material-ui/icons/Check"), require("@material-ui/icons/CheckBoxOutlineBlank"), require("@material-ui/icons/ChevronRight"), require("@material-ui/icons/Timelapse"), require("react"), require("react-router-dom")) : "function" == typeof define && define.amd ? define(["exports", "@material-ui/core", "@material-ui/core/styles", "@material-ui/icons/Check", "@material-ui/icons/CheckBoxOutlineBlank", "@material-ui/icons/ChevronRight", "@material-ui/icons/Timelapse", "react", "react-router-dom"], t) : t((e = e || self)["fab-checklist"] = {}, e.core, e.styles, e.Check, e.CheckBoxOutlineBlank, e.ChevronRight, e.Timelapse, e.React, e.reactRouterDom);
}(this, function (e, t, n, o, r, a, i, l, c) {
  "use strict";

  o = o && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o, r = r && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r, a = a && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a, i = i && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;

  var s = "default" in l ? l.default : l,
      u = [{
    id: "xk-1",
    label: "Volunteer profile",
    status: "complete",
    to: "/applicant/volunteer-contract",
    value: 20,
    openOnComplete: !1
  }, {
    id: "xk-2",
    label: "Join an activity",
    status: "complete",
    to: "/volunteering/activities/all-activities",
    value: 30,
    openOnComplete: !0
  }, {
    id: "xk-3",
    label: "Join an activity",
    status: "active",
    to: "/volunteering/my-activities?enrolInfo=1",
    value: 10,
    openOnComplete: !0,
    isPassiveAction: !0
  }, {
    id: "xk-4",
    label: "Wait to be rostered",
    status: "incomplete",
    to: "/volunteering/my-activities?rosterInfo=1",
    value: 25,
    openOnComplete: !0,
    isPassiveAction: !0
  }, {
    id: "xk-5",
    label: "View activity information",
    status: "incomplete",
    to: "/volunteering/my-activities",
    value: 15,
    openOnComplete: !0
  }],
      m = t.makeStyles(function () {
    return n.createStyles({
      icon: {
        minWidth: "0px",
        marginRight: "8px"
      },
      check: {
        color: "green",
        fontSize: "50"
      },
      colorPrimary: {
        backgroundColor: "#2196f3"
      },
      barColorPrimary: {
        backgroundColor: "#c0e2fc"
      }
    });
  }),
      p = function p(e) {
    var n = e.completionPercentage,
        r = e.toggleShowFab,
        a = e.openChecklist,
        i = l.useState(!1),
        c = i[0],
        u = i[1],
        p = m();
    return s.createElement(s.Fragment, null, s.createElement(t.Grow, {
      in: n < 100,
      unmountOnExit: !0,
      onExited: function onExited() {
        return u(!0);
      },
      timeout: 500
    }, s.createElement(t.Box, null, s.createElement(t.Typography, {
      display: "inline",
      style: {
        color: a ? "#282828" : "#fff",
        fontWeight: "bold",
        fontSize: "13px"
      }
    }, n), s.createElement(t.Typography, {
      display: "inline",
      style: {
        color: a ? "#282828" : "#fff",
        fontWeight: "bold",
        fontSize: "13px"
      }
    }, "%"))), s.createElement(t.Grow, {
      in: c,
      unmountOnExit: !0,
      timeout: 500,
      onEntered: function onEntered() {
        return r(!1);
      }
    }, s.createElement(o, {
      className: p.check,
      fontSize: "large",
      style: {
        color: "#fff"
      }
    })));
  },
      d = function d(e) {
    var n = e.status,
        l = e.label,
        c = e.isPassiveAction,
        u = t.useTheme();
    if (!u) throw new Error("FabChecklist requires a Material-UI Theme");
    var p = m();
    return s.createElement(t.ListItem, {
      style: {
        background: "active" === n ? u.palette.grey[200] : u.palette.background.paper,
        marginBottom: "10px",
        borderTopLeftRadius: "5px",
        borderBottomLeftRadius: "5px",
        boxShadow: "-3px 3px 5px 0px rgba(0, 0, 0, 0.3)"
      }
    }, "complete" === n ? s.createElement(t.ListItemIcon, {
      classes: {
        root: p.icon
      }
    }, s.createElement(o, {
      fontSize: "small",
      style: {
        color: "rgb(125, 210, 104)"
      }
    })) : "active" === n ? s.createElement(t.ListItemIcon, {
      classes: {
        root: p.icon
      }
    }, c ? s.createElement(i, null) : s.createElement(a, {
      style: {
        color: "#2196f3"
      }
    })) : s.createElement(t.ListItemIcon, {
      classes: {
        root: p.icon
      }
    }, s.createElement(r, null)), "active" === n ? s.createElement(s.Fragment, null, c ? s.createElement(t.Button, {
      style: {
        textTransform: "none"
      },
      variant: "text"
    }, l) : s.createElement(t.Button, {
      style: {
        textTransform: "none",
        backgroundColor: "#2196f3",
        color: "white"
      },
      variant: "contained"
    }, l)) : "complete" === n ? s.createElement(t.Typography, {
      variant: "button",
      color: "textSecondary",
      style: {
        textTransform: "none"
      }
    }, l) : s.createElement(t.Button, {
      disabled: !0,
      style: {
        textAlign: "start",
        textTransform: "none"
      }
    }, l));
  },
      f = function f(e) {
    var n = e.item,
        o = e.stepNumber,
        r = e.openChecklist,
        a = e.currentStep,
        i = e.closeChecklist,
        l = 50 * o,
        u = a || 1 !== o ? a + 1 === o ? "active" : a + 1 > o ? "complete" : "incomplete" : "active";
    return 2 === a && 2 === o ? null : 3 === a && 3 === o ? null : 2 !== a && 3 !== a && 3 === o ? null : s.createElement(t.Slide, {
      direction: "left",
      in: r,
      timeout: {
        enter: l,
        exit: 150
      },
      style: {
        width: "100%"
      }
    }, s.createElement(t.Box, {
      style: {
        width: "100%"
      },
      onClick: "active" === u ? i : void 0
    }, "active" !== u ? s.createElement(d, {
      status: u,
      label: n.label,
      isPassiveAction: n.isPassiveAction || !1
    }) : s.createElement(c.Link, {
      to: n.to,
      style: {
        width: "100%",
        textDecoration: "none"
      }
    }, s.createElement(d, {
      status: u,
      label: n.label,
      isPassiveAction: n.isPassiveAction || !1
    }))));
  };

  e.FabChecklist = function (e) {
    var n = e.currentStep,
        o = e.isMobile,
        r = l.useState(n),
        a = r[0],
        i = r[1],
        c = l.useState(!1),
        d = c[0],
        x = c[1],
        y = l.useState(!0),
        h = y[0],
        v = y[1],
        b = m(),
        g = t.useTheme();
    if (!g) throw new Error("FabChecklist requires a Material-UI Theme");

    for (var E = 0, k = 0; k < n; k++) E += u[k].value;

    return l.useEffect(function () {
      n === a || n >= u.length || (n > a && u[n].openOnComplete && x(!0), i(n));
    }, [n]), s.createElement(t.Box, {
      position: "flex",
      margin: "0px",
      padding: "0px 0px 0px 10px",
      bgcolor: "rgba(0,0,0,0)",
      color: g.palette.background.paper,
      style: {
        transition: "750ms",
        pointerEvents: d ? "auto" : "none",
        display: o ? "none" : ""
      },
      zIndex: g.zIndex.modal
    }, s.createElement(t.ClickAwayListener, {
      onClickAway: function onClickAway(e) {
        d && (e.preventDefault(), d && x(!1));
      }
    }, s.createElement(t.Box, null, s.createElement(t.List, {
      style: {
        position: "fixed",
        width: "75%",
        top: "57px",
        right: "0px",
        margin: "0px",
        maxWidth: "350px",
        maxHeight: "calc(100vh - 102px)",
        background: "rgba(0,0,0,0)",
        boxShadow: "none",
        padding: "10px 0px 0px 10px",
        overflow: d ? "" : "hidden"
      }
    }, u.map(function (e, t) {
      return s.createElement(f, {
        key: e.id,
        item: e,
        stepNumber: t + 1,
        openChecklist: d,
        currentStep: n,
        closeChecklist: function closeChecklist() {
          return x(!1);
        }
      });
    })), s.createElement(t.Fade, {
      in: h,
      timeout: {
        appear: 0,
        enter: 0,
        exit: 2e3
      },
      unmountOnExit: !0,
      enter: !1
    }, s.createElement(t.Box, {
      display: "flex",
      alignItems: "center",
      zIndex: g.zIndex.modal + 1
    }, s.createElement(t.Button, {
      variant: "contained",
      "aria-label": "test",
      onClick: function onClick() {
        x(!d);
      },
      style: {
        pointerEvents: "all",
        background: d ? "#fff" : "#7a6e8f",
        padding: o ? "6px 10px" : "6px 16px"
      }
    }, s.createElement(p, {
      openChecklist: d,
      completionPercentage: E,
      toggleShowFab: v
    }), s.createElement(t.LinearProgress, {
      variant: "determinate",
      value: E,
      classes: d ? {
        colorPrimary: b.barColorPrimary,
        barColorPrimary: b.colorPrimary
      } : {},
      style: {
        pointerEvents: "none",
        marginLeft: o ? 5 : 10,
        height: "10px",
        width: o ? 30 : 100,
        borderRadius: "5px"
      }
    })))))));
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});